import { render, staticRenderFns } from "./userDig.vue?vue&type=template&id=ae0676aa&scoped=true"
import script from "./userDig.vue?vue&type=script&lang=js"
export * from "./userDig.vue?vue&type=script&lang=js"
import style0 from "./userDig.vue?vue&type=style&index=0&id=ae0676aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0676aa",
  null
  
)

export default component.exports